var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuhler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 33,
    viewBox: "0 0 200 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_327)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_466_327",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 0,
    width: 175,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.005 0.5H16.0052V32.5H190.005V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_466_327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2825 16.805L92.3534 9.07617H88.7199L87.649 16.805H91.2825Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.943 5.23046L189.462 5.19239L190.151 0.166748H34.2179C23.7382 0.166748 15.8211 7.40062 15.8211 16.3098C15.8211 25.2188 23.7382 32.4527 34.2179 32.4527H44.2769L44.8124 28.5693C39.0753 27.7697 34.7916 21.7161 35.6713 15.5483C36.5128 9.685 41.9056 5.23046 48.943 5.23046Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.042 9.07617H171.486L168.197 32.453H174.278L175.349 24.7242H177.491L181.316 32.453H188.124L183.802 24.077C186.823 23.0109 188.965 20.5742 189.462 17.0334C190.189 11.9317 187.091 9.07617 182.042 9.07617ZM183.458 17.0334C183.19 18.7467 182.042 19.8508 179.862 19.8508H176.038L176.841 14.216H180.666C182.846 14.216 183.687 15.3202 183.458 17.0334Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.332 9.07617H131.174L127.885 32.453H143.642L144.369 27.1609H134.769L137.332 9.07617Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.434 32.453H163.225L163.952 27.1609H153.204L153.778 23.1251H163.607L164.334 17.9853H154.505L155.04 14.3303H165.787L166.514 9.07617H149.724L146.434 32.453Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5694 9.07617H57.5104L54.2211 32.453H65.0068C69.9024 32.453 73.1152 30.1306 73.7271 25.9045C74.1096 23.2774 72.8092 21.1073 70.6674 20.3839C72.5032 19.7747 74.1478 17.9472 74.5303 15.4344C75.104 11.2463 72.465 9.07617 67.5694 9.07617ZM67.9136 25.1811C67.7223 26.5136 66.6132 27.4274 64.8921 27.4274H60.7614L61.4116 22.8967H65.5423C67.2634 22.8967 68.1048 23.7724 67.9136 25.1811ZM68.6403 16.1958C68.449 17.6426 67.3781 18.3279 65.5805 18.3279H62.0618L62.6737 14.1018H66.1925C67.9901 14.1018 68.8315 14.7491 68.6403 16.1958Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.782 17.9472H110.635L111.897 9.07617H105.74L102.45 32.453H108.608L109.909 23.2013H118.055L116.755 32.453H122.913L126.202 9.07617H120.044L118.782 17.9472Z",
    fill: "#00A99C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7741 22.3637C92.3152 25.676 90.5176 27.3893 87.9932 27.3893C85.4307 27.3893 84.0921 25.676 84.551 22.3637L86.4251 9.07617H80.3056L78.355 22.8967C77.4371 29.331 80.994 32.8338 87.1901 32.8338C93.3861 32.8338 97.8992 29.331 98.8171 22.9348L100.768 9.07617H94.6482L92.7741 22.3637Z",
    fill: "#00A99C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 32,
    fill: "white",
    transform: "translate(0.00518799 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuhler);
export default __webpack_public_path__ + "static/media/buhler.e8a332841f19f54feb62e92c00e2c121.svg";
export { ForwardRef as ReactComponent };